class FixedImage extends HTMLElement {
  constructor() {
    super()
    this.observer = null
    this.image = null
  }

  connectedCallback() {
    this.image = this.querySelector('img')

    if (!this.image) return

    // Find parent section that contains this fixed image
    this.parentSection = this.closest('section')

    if (!this.parentSection) return

    // Set initial opacity to 0 and add transition class
    this.image.style.opacity = '0'

    // Create and configure the Intersection Observer
    this.observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            // Fade in the image
            this.image.style.opacity = '1'
          } else {
            // Fade out the image
            this.image.style.opacity = '0'
          }
        })
      },
      {
        root: null,
        rootMargin: '0px',
        threshold: 0.1, // Trigger when at least 10% of the element is visible
      }
    )

    // Start observing the parent section
    this.observer.observe(this.parentSection)
  }

  disconnectedCallback() {
    // Clean up the observer when the element is removed
    if (this.observer && this.parentSection) {
      this.observer.unobserve(this.parentSection)
      this.observer = null
    }
  }
}

// Register the custom element
if (!customElements.get('fixed-image')) {
  customElements.define('fixed-image', FixedImage)
}
